import React, { useEffect, useState } from 'react';
import { Col, Radio, Row, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { AllSubjectAreasTreeSelector } from '../../components/AllSubjectAreasTreeSelector/AllSubjectAreasTreeSelector';
import {
  BlueLayout,
  CustomButton,
  FormBlock,
  FormInput,
  FormItem,
  GridItem,
  PagesContainerUI,
} from '../../styles/styled';
import { TextbookSearchSubjectsType } from '../Mainpage/types';
import { BookType } from '../NewApplicationPage/types';
import { EditTextbookInputsType } from './types';

export const EditTextbook = () => {
  const { id } = useParams();
  const [currentBookState, setCurrentBook] = useState<BookType | null>(null);
  const [inputsState, setInputs] = useState<EditTextbookInputsType>({});
  const [subjectsState, setSubjects] = useState<TextbookSearchSubjectsType>({});
  const navigate = useNavigate();
  const [treeSelectorStringState, setTreeSelectorString] = useState<string>('');
  const [noEduLvlState, setNoEduLvl] = useState<boolean>(false);

  const putData = () => {
    if (id) {
      navigate(-1);
      api.put(endpoints.putTextbook(id), { ...inputsState, no_edu_lvl_in_number: noEduLvlState });
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const response = await api.get<BookType>(endpoints.getTextbookId(id));

          const publicSubjectsResponse = await api.get<TextbookSearchSubjectsType>(endpoints.getPublicSubjectLists());

          if (response.data.subject?.title) {
            setTreeSelectorString(response.data.subject?.title);
          }

          if (response.data.no_edu_lvl_in_number) setNoEduLvl(response.data.no_edu_lvl_in_number);

          setSubjects(publicSubjectsResponse.data);
          setCurrentBook(response.data);
        } catch (err) {}
      })();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return currentBookState ? (
    <PagesContainerUI>
      <BlueLayout padding="40px 0">{currentBookState.title}</BlueLayout>

      <FormBlock>
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <FormItem>
              <div className="text">Учебный предмет</div>
              <AllSubjectAreasTreeSelector
                subjectsState={subjectsState}
                treeSelectorStringState={treeSelectorStringState}
                setParentState={(value) => {
                  setInputs({
                    ...inputsState,
                    subject: {
                      id: parseInt(value.split('[unique]')[0]),
                    },
                  });
                  setTreeSelectorString(value.split('[fUni]')[1]);
                }}
              />
            </FormItem>
          </Col>
          <Col span={8}>
            <GridItem align="flex-start" direction="row" wrap="wrap">
              <div className="text">Две последние цифры</div>
              <Row gutter={[20, 20]}>
                <Col span={12}>
                  <FormInput
                    onChange={(e) => setInputs({ ...inputsState, subject_series: parseInt(e.target.value) })}
                    defaultValue={currentBookState.subject_series}
                    value={inputsState?.subject_series}
                    type="number"
                  />
                </Col>
                <Col span={12}>
                  <FormInput
                    onChange={(e) => setInputs({ ...inputsState, subject_series_number: parseInt(e.target.value) })}
                    defaultValue={currentBookState.subject_series_number}
                    value={inputsState?.subject_series_number}
                    type="number"
                  />
                </Col>
              </Row>
            </GridItem>
          </Col>
          <Col span={24}>
            <FormItem>
              <div className="text">Отсутствие уровня образования в номере</div>
              <Radio.Group value={noEduLvlState} onChange={(e) => setNoEduLvl(e.target.value)}>
                <Radio value={true}>Да</Radio>
                <Radio value={false}>Нет</Radio>
              </Radio.Group>
            </FormItem>
          </Col>
        </Row>
        <GridItem align="center" justify="center">
          <CustomButton onClick={() => putData()}>Сохранить</CustomButton>
        </GridItem>
      </FormBlock>
    </PagesContainerUI>
  ) : (
    <Spin />
  );
};
